
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online-olimpiadalar",
      function () {
        return require("private-next-pages/online-olimpiadalar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online-olimpiadalar"])
      });
    }
  